const setThermostatsList = (context, thermostatsList) => {
  context.commit('THERMOSTATS_LIST', thermostatsList);
};

export default {
  setThermostatsList,
};
